export const TOTAL = "Total";
export const SELECTED_ITEMS = "Items seleccionados";
